
import { Attachment, InstructionItem, RecipeImage } from "@/types/recipes";
import {
  defineComponent,
  PropType,
  ref,
  ComponentPublicInstance,
  onMounted,
  nextTick,
  computed,
  SetupContext
} from "vue";
import DetailInstructionItem from "./DetailInstructionItem.vue";
import NativeClient from "@/client/native-client";
import { ApplianceData, AttachmentData } from "@/types/common";

export default defineComponent({
  components: { DetailInstructionItem },
  name: "DetailInstructionsView",
  props: {
    instructions: {
      type: Array as PropType<InstructionItem[]>,
      default: () => null
    },
    applianceCategory: {
      type: String,
      required: true
    },
    applianceCategoryId: {
      type: Number,
      required: true
    },
    update: {
      type: Boolean,
      required: true
    },
    applianceData: {
      type: ApplianceData,
      require: true
    },
    recipeAttachmenList: {
      type: Array as PropType<Attachment[]>
    },
    attachmentList: {
      type: Array as PropType<AttachmentData[]>,
      require: true
    },
    pageScrollTop: {
      type: Number,
      require: true
    }
  },
  setup(props, context: SetupContext) {
    const getImage = (imageList: Array<RecipeImage>) => {
      if (imageList && imageList.length != 0) {
        const images = imageList[0];
        if (images == null) {
          return "";
        }
        if (images.main != null) {
          return images.main;
        } else if (images.thumb != null) {
          return images.thumb;
        }
      }
      return "";
    };

    const setInstructionItemPosition = (id: number, rect: DOMRect, pageScrollTop: number) => {
      context.emit("set-instruction-item-position", id, rect, pageScrollTop);
    };

    const clickBistroSend = (dlMenuId: number) => {
      context.emit("click-bistro-send", dlMenuId);
    };

    const clickBistroSendLink = (type: string) => {
      context.emit("click-bistro-send-link", type);
    };

    return {
      getImage,
      setInstructionItemPosition,
      clickBistroSend,
      clickBistroSendLink
    };
  }
});
